import { useNavigate, useParams } from 'react-router-dom';
import AccountStatement from '@/components/CuentaCorriente/AccountStatement.jsx';

export default function CuentaCorrienteCliente() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <div className="mx-auto w-full max-w-[1500px] px-3 py-4">
      <button type="button" onClick={() => navigate(-1)} className="mb-3 rounded-lg border px-3 py-1.5 text-xs font-semibold">
        Volver
      </button>
      <AccountStatement clienteId={id} mode="full" />
    </div>
  );
}
